import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import endpoints from '../../config/endpoints';
import { Sidebar } from '../../layouts/Sidebar';
import { setLoading } from '../../services/reducers/homeSlice';
import restApi from '../../services/restApi';
import tools from '../../utils/tools';

const PaymentMethodManage = () => {
  const { id: paramId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form, setForm] = useState<any>({});

  const send = async () => {
    dispatch(setLoading(true));

    const res = await restApi(endpoints.paymentMethod.basic + (paramId || '')).post(tools.extractor(form, ['title', 'description']));

    if (res.code == 200) {
      Swal.fire({
        title: 'موفق',
        text: `نحوه پرداخت با موفقیت ${paramId ? 'ویرایش' : 'ایجاد'} شد`,
        icon: 'success',
        confirmButtonText: 'متوجه شدم',
        didClose() {
          navigate('/paymentMethod')
        }
      });
    } else {
      Swal.fire({
        title: 'ناموفق',
        text: res?.data,
        icon: 'error',
        confirmButtonText: 'متوجه شدم'
      });
    }

    dispatch(setLoading(false));
  };

  const fetchItem = async () => {
    dispatch(setLoading(true));

    const res = await restApi(endpoints.paymentMethod.single + paramId, true).get();

    if (res.code == 200) {
      setForm({
        title: res.data?.title,
        description: res.data?.description
      });
    }

    dispatch(setLoading(false));
  };

  useEffect(() => {
    paramId && fetchItem();
  }, []);

  return (
    <>
      <body className="dashboardBody">
      <Sidebar/>
      <main className="dashBoardMain main">
        <div className="addInfoHeader">
          <span className="dashboardHeader keepRight clickable" onClick={send}>
           {paramId ? 'ویرایش ' : 'ایجاد '}نحوه پرداخت
          </span>
          <span>
            <h1 className="sideBarTitle">بازگشت به صفحه نحوه پرداخت</h1>
             <h1 className="dashBoardTitle">{paramId ? 'ویرایش' : 'ایجاد'} نحوه پرداخت </h1>
          </span>
          <i className="backAdd clickable" onClick={() => navigate('/paymentMethod/')}></i>
        </div>
        <section className="bottomSection">
          <h1 className="dashBoardTitle">اطلاعات نحوه پرداخت</h1>
          <form className="addInfo">
            <label className="sideBarTitle" htmlFor="infoTitle">عنوان</label>
            <input className="addInput" id="infoTitle" onChange={(input: any) => setForm(prev => ({
              ...prev,
              title: input.target.value
            }))} value={form.title}/>
            <label className="sideBarTitle" htmlFor="infoAmount">توضیحات</label>
            <textarea className="addInput" placeholder="توضیحات" id="infoAmount" onChange={(input: any) => setForm((prev) => {
              return {
                ...prev,
                description: input.target.value
              };
            })} value={form.description}/>
          </form>
        </section>
      </main>
      </body>
    </>
  );
};
export default PaymentMethodManage;